import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ShieldCheck, Star } from 'lucide-react';
export function Pricing() {
  return <Section id="pricing" className="bg-white" data-id="element-58">
      <div className="max-w-lg mx-auto bg-white rounded-3xl shadow-2xl border-2 border-rose-100 overflow-hidden" data-id="element-59">
        <div className="bg-rose-50 p-4 text-center border-b border-rose-100" data-id="element-60">
          <span className="text-rose-700 font-bold text-sm uppercase tracking-wider" data-id="element-61">
            Oferta Especial de Lanzamiento
          </span>
        </div>

        <div className="p-8 md:p-10 text-center" data-id="element-62">
          <h2 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-63">
            Mamá Digital
          </h2>
          <p className="text-gray-500 mb-6" data-id="element-64">El sistema completo + Bonos</p>

          <div className="flex items-center justify-center mb-8" data-id="element-65">
            <span className="text-gray-400 text-2xl line-through mr-4" data-id="element-66">
              $97
            </span>
            <span className="text-5xl font-extrabold text-emerald-600" data-id="element-67">
              $6.39
            </span>
            <span className="text-gray-500 text-xl ml-2" data-id="element-68">USD</span>
          </div>

          <ul className="text-left space-y-3 mb-8 max-w-xs mx-auto" data-id="element-69">
            <li className="flex items-center text-gray-700" data-id="element-70">
              <Star className="w-5 h-5 text-amber-400 mr-2 fill-current" data-id="element-71" />
              <span data-id="element-72">Ebook Completo (PDF)</span>
            </li>
            <li className="flex items-center text-gray-700" data-id="element-73">
              <Star className="w-5 h-5 text-amber-400 mr-2 fill-current" data-id="element-74" />
              <span data-id="element-75">Sistema CELU-VENTAS</span>
            </li>
            <li className="flex items-center text-gray-700" data-id="element-76">
              <Star className="w-5 h-5 text-amber-400 mr-2 fill-current" data-id="element-77" />
              <span data-id="element-78">Plan de Acción 7 Días</span>
            </li>
            <li className="flex items-center text-gray-700" data-id="element-79">
              <Star className="w-5 h-5 text-amber-400 mr-2 fill-current" data-id="element-80" />
              <span data-id="element-81">Scripts de Venta para WhatsApp</span>
            </li>
          </ul>

          <Button fullWidth className="mb-4" data-id="element-82">
            ¡Sí, quiero descargar la guía!
          </Button>

          <p className="text-xs text-gray-400 mb-6" data-id="element-83">
            Pago único y seguro. Acceso inmediato.
          </p>

          <div className="flex items-center justify-center text-sm text-gray-500 bg-gray-50 py-3 rounded-lg" data-id="element-84">
            <ShieldCheck className="w-5 h-5 text-emerald-500 mr-2" data-id="element-85" />
            <span data-id="element-86">Garantía de satisfacción de 30 días</span>
          </div>
        </div>
      </div>
    </Section>;
}